import { APIServiceError } from "components/AppErrors";
import { fetchWithTimeout } from "utils";
import config from "config";
import {
    GetProductsResponse,
    GetTitlesResponse,
    MembershipPurchaseRequest,
    MembershipPurchaseResponse,
    TokenisationKeyResponse,
} from "./Types";

// Can make this into a hook (useAPIService) to make it cleaner and support raising errors from the various operations
// At this point we throw in two places, one if we don't get a response.ok, and another if fetch fails maybe due to a network error
// They allow us used the CustomError

export const getProducts = async (): Promise<GetProductsResponse> => {
    try {
        const response = await fetchWithTimeout(`${config.roadsideApi.baseUrl}api/Products`);
        if (!response.ok) {
            throw new APIServiceError(await response.text());
        }

        return (await response.json()) as GetProductsResponse;
    } catch (error: unknown) {
        if (error instanceof APIServiceError) throw error;
        throw new APIServiceError(error instanceof Error ? error.message : String(error));
    }
};

export const getTitles = async (): Promise<GetTitlesResponse> => {
    try {
        const response = await fetchWithTimeout(`${config.roadsideApi.baseUrl}api/Titles`);
        if (!response.ok) {
            throw new APIServiceError(await response.text());
        }
        return (await response.json()) as GetTitlesResponse;
    } catch (error: unknown) {
        if (error instanceof APIServiceError) throw error;
        throw new APIServiceError(error instanceof Error ? error.message : String(error));
    }
};

export type PurchaseApiEndpoint = "api/MembershipPurchase" | "api/FreeLifestyleMembershipPurchase";

export const postMembershipPurchase = async (
    request: MembershipPurchaseRequest,
    purchaseEndpoint: PurchaseApiEndpoint,
): Promise<MembershipPurchaseResponse> => {
    try {
        const response = await fetchWithTimeout(`${config.roadsideApi.baseUrl}${purchaseEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(request),
        });

        if (!response.ok) {
            throw new APIServiceError(await response.text());
        }

        return (await response.json()) as MembershipPurchaseResponse;
    } catch (error: unknown) {
        if (error instanceof APIServiceError) throw error;
        throw new APIServiceError(error instanceof Error ? error.message : String(error));
    }
};

export const getTokenisationKey = async (): Promise<TokenisationKeyResponse> => {
    try {
        const response = await fetchWithTimeout(`${config.roadsideApi.baseUrl}api/TokenisationKey`);
        if (!response.ok) {
            throw new APIServiceError(await response.text());
        }
        return (await response.json()) as TokenisationKeyResponse;
    } catch (error: unknown) {
        if (error instanceof APIServiceError) throw error;
        throw new APIServiceError(error instanceof Error ? error.message : String(error));
    }
};
